import React from "react";
import { Box, Button, Grid, Modal, TextField } from "@mui/material";

import { useApp } from "../contexts/app";

const style = {
  bgcolor: "background.paper",
  boxShadow: 24,
};

export const LocalGameSetup = ({
  isOpen,
  close,
  settings,
}: {
  isOpen: boolean;
  close: () => void;
  settings: {
    players: {
      name: string;
      setName: (name: string) => void;
    }[];
  };
}) => {
  const { dispatch } = useApp();

  return (
    <Modal
      open={isOpen}
      onClose={close}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        className="contain-sm"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Box
          sx={style}
          className="d-flex flex-column justify-content-center align-items-center p-5"
        >
          <Grid>
            {settings.players.map((p, i) => (
              <Grid key={i} item xs={settings.players.length} md={1}>
                <TextField
                  className="m-2"
                  variant="outlined"
                  label={`Player ${i + 1}`}
                  value={p.name}
                  onChange={(e) => p.setName(e.target.value)}
                />
              </Grid>
            ))}
          </Grid>

          <Button
            className="mt-4"
            onClick={() => {
              dispatch({
                type: "INITIALIZE_GAME",
                payload: {
                  players: [
                    settings.players[0].name || "White",
                    settings.players[1].name || "Black",
                  ],
                  onlineGameId: null,
                  localPlayerId: null,
                },
              });
            }}
            variant="contained"
            size="large"
          >
            START !
          </Button>
        </Box>
      </div>
    </Modal>
  );
};
